<template>
  <div :class="$style['container']">
    <div :class="$style['wrapper']">
      <div :class="$style['line']" v-background-color="colorSecondary" />
      <div
        :class="$style['circle']"
        :key="page"
        v-for="page in pages"
        v-background-color="getBackgroundColor(index === page)"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    colorPrimary: {
      type: String,
      default: '',
    },
    colorSecondary: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    pages() {
      return [...Array(4).keys()]
    },
  },
  methods: {
    getBackgroundColor(isActive) {
      if (isActive) {
        return this.colorPrimary
      }
      return '#2f2f2f'
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.container {
  position: relative;
}
.wrapper {
  display: inline-block;
  position: relative;
}
.circle {
  border-radius: 50%;
  display: inline-block;
  height: 10px;
  margin-right: 15px;
  position: relative;
  width: 10px;
  z-index: 1;
  &:last-child {
    margin-right: 0;
  }
}
.line {
  height: 1px;
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
}
</style>
